export const getFrontendBaseUrl = () => {
  const url = process.env.REACT_APP_FRONTEND_URL || window.location.origin;
  return url.replace(/\/+$/, "");
};

export const getPropertyPath = (slug) => `/properties/${slug}`;
